'use client';
import { TDetailsProps, TabsVariant } from 'types';
import { CustomModal } from '../custom-modal';
import { Tabs } from '../tabs';
import { Highlights } from './highlights';
import { Includes } from './include';

export const Details = (props: TDetailsProps) => {
  const { open, onCloseClick } = props;

  return (
    <CustomModal open={open} onCloseClick={onCloseClick} className="overflow-y-auto max-w-[50vw] h-[70vh]">
      <Tabs defaultTabId="1" variant={TabsVariant.UNDERLINE} className="py-6">
        <Tabs.TabList className="w-fit mx-auto py-4">
          <Tabs.Tab tabId="1">Høydepunkter</Tabs.Tab>
          <Tabs.Tab tabId="2">Hva inkluderer pakken</Tabs.Tab>
        </Tabs.TabList>
        <Tabs.TabPanel tabId="1">
          <Highlights {...props} />
        </Tabs.TabPanel>
        <Tabs.TabPanel tabId="2">
          <Includes {...props} />
        </Tabs.TabPanel>
      </Tabs>
    </CustomModal>
  );
};
